import { EntitiesState } from '@redux/entities'

export function getLatestCommentWithAttachment(commentIds: number[], comments: EntitiesState['comments']) {
  let latest = {}

  commentIds
    .slice()
    .reverse()
    .some((commentId) => {
      const comment = comments[commentId] || {}

      // @ts-expect-error TS2339
      if (comment.attachments?.length){
        latest = comment
        return true
      }

      return false
    })

  return latest
}

export default getLatestCommentWithAttachment
